import React from "react"
import { Tab } from "@reach/tabs"

export const StyledTab: React.FC = (props) => (
  <Tab className="btn tab-button" {...props} />
)
